export const updateQuestionInputValue = event => {
  const $target = event.currentTarget;
  const $question = $target.closest('.js-quizQuestion');
  const $boundTo = $question.querySelector('.js-quizQuestionInput');
  $boundTo.value = $target.textContent;
};
